import { useLanguage } from "@/lib/i18n/LanguageContext";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

import type { LoadState } from "@/stores/connectors/loading";

export function ConnectorStatus({ state, retry }: { state: LoadState; retry: () => void }) {
  const { t } = useLanguage();
  const copy = t.connectors;
  if (state === "unavailable" || state === "loading") return <p role="status">{copy[state]}</p>;
  return (
    <div className="space-y-4">
      <Alert variant="destructive">
        <AlertDescription>{copy[state]}</AlertDescription>
      </Alert>
      {state === "failed" && (
        <Button variant="outline" onClick={retry}>
          {copy.retry}
        </Button>
      )}
    </div>
  );
}
